export const base_path ='/' // "/react/template";
export const image_path ='' // '/react/template/'